/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SkillSuggestion } from './';
import {
    SkillSuggestionFromJSON,
    SkillSuggestionFromJSONTyped,
    SkillSuggestionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkillSuggestions
 */
export interface SkillSuggestions {
    /**
     * 
     * @type {Array<SkillSuggestion>}
     * @memberof SkillSuggestions
     */
    suggestedSkills?: Array<SkillSuggestion>;
}

/**
 * Check if a given object implements the SkillSuggestions interface.
 */
export function instanceOfSkillSuggestions(value: object): value is SkillSuggestions {
    return true;
}

export function SkillSuggestionsFromJSON(json: any): SkillSuggestions {
    return SkillSuggestionsFromJSONTyped(json, false);
}

export function SkillSuggestionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillSuggestions {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestedSkills': json['suggestedSkills'] == null ? undefined : ((json['suggestedSkills'] as Array<any>).map(SkillSuggestionFromJSON)),
    };
}

export function SkillSuggestionsToJSON(value?: SkillSuggestions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestedSkills': value['suggestedSkills'] == null ? undefined : ((value['suggestedSkills'] as Array<any>).map((v) => SkillSuggestionToJSON(v))),
    };
}

